export default "__VITE_ASSET__9d7c9f9f__"